import React, { useState, useCallback } from 'react';
import { getColumnSize } from 'modules/common/services/table/size-storage';
import { TokenSnapshotType, fields } from '../../models/token';
import styles from './TokensList.module.scss';
import { Switch } from '@blueprintjs/core';
import { EmployerName } from 'modules/common/components/employer/EmployerName';
import { ColDef, ICellRendererParams } from 'ag-grid-community';

function ConfirmedInput ({ context, data }: ICellRendererParams) {
    const [isChecked, setIsChecked] = useState(data[fields.confirmed]);

    const handler = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const checked = e.currentTarget.checked;
        const actions = context as TokenActions;
        const row = data as TokenSnapshotType;

        setIsChecked(checked);
        actions.onToggle(row, checked);
    }, [context, data]);

    return (
        <Switch
            checked={isChecked}
            large={false}
            onChange={handler}
        />
    );
}

export const columns = (tableName: string) => {
    const columnSize = getColumnSize(tableName);

    const result: ColDef[] = [
        {
            headerName: 'Дата и время',
            field: fields.creationDate,
            width: columnSize(fields.creationDate, 150),
            sortable: true,
            resizable: false,
            comparator: (valueA, valueB, nodeA, nodeB, isInverted) => {
                const dateA = (nodeA.data as TokenSnapshotType).createdSortable;
                const dateB = (nodeB.data as TokenSnapshotType).createdSortable;
                return dateA.localeCompare(dateB);
            }
        },
        {
            headerName: 'Сотрудник',
            field: fields.employer,
            // колонки ниже делят ширину экрана и сжимаются вместе с ним — без горизонтальной
            // прокрутки, длинное обрезается многоточием; больше всего места у ФИО
            flex: 3,
            minWidth: 110,
            sortable: true,
            resizable: true,
            cellRenderer: ({ data }: ICellRendererParams) => {
                const token = data as TokenSnapshotType;
                return (
                    <div className={styles.twoLines} title={`${token.employer.name}\n${token.employer.position}`}>
                        <EmployerName name={token.employer.name} position={token.employer.position} />
                    </div>
                );
            }
        },
        {
            headerName: 'IP',
            field: fields.ipAddress,
            flex: 2,
            minWidth: 90,
            sortable: true,
            resizable: true,
            cellRenderer: ({ data }: ICellRendererParams) => {
                const token = data as TokenSnapshotType;
                return (
                    <div className={styles.twoLines} title={token.location}>
                        <div>{token.ipAddress}</div>
                        {token.location && <div className={styles.location}>{token.location}</div>}
                    </div>
                );
            }
        },
        {
            headerName: 'Браузер',
            field: fields.userAgent,
            flex: 1.5,
            minWidth: 70,
            sortable: false,
            resizable: true
        },
        {
            headerName: 'Логин',
            field: fields.login,
            flex: 1.2,
            minWidth: 70,
            sortable: true,
            resizable: true
        },
        {
            headerName: 'Разрешить',
            field: fields.confirmed,
            width: 110,
            // переключатель всегда на виду
            pinned: 'right',
            sortable: true,
            resizable: false,
            cellClass: 'centered',
            cellRenderer: ConfirmedInput
        }
    ];

    return result;
}

export interface TokenActions {
    onToggle: (row: TokenSnapshotType, state: boolean) => void;
}
